export const RE_INITIALIZE_ORDER_FILTER = 'RE_INITIALIZE_ORDER_FILTER'
export const SET_ORDER_FILTER = 'SET_ORDER_FILTER'
